import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";
import { http } from "./https";
import States from './Components/Commons/States';
import { buildAuthorizationHeader } from './Components/Commons/AuthHeaders';

const domain = process.env.REACT_APP_URL_API ?? "";

const withValidations = (Component) => (props) => {
    const { isAuthenticated, getIdTokenClaims, getAccessTokenSilently, loginWithRedirect } = useAuth0();
    const [com, setCom] = useState(<span>Espere...</span>);

    useEffect(() => {
        (async () => {
            try {
                var claims = await getIdTokenClaims();
                if (!isAuthenticated) {
                    setCom(<div><span>Error no estas autenticado</span></div>);
                    return;
                }

                if (!claims?.email_verified) {
                    setCom(<div className="centered"><div className="child"><span>Antes de continuar verifica tu email.</span></div></div>);
                    return;
                }

                try {
                    http(new Request(`${domain}/HandShake`, {
                        method: 'GET',
                    }));

                    // Antes esto se resolvia haciendo un client_credentials directo contra
                    // Auth0 DESDE EL NAVEGADOR, con un client_secret embebido en el bundle de
                    // React (REACT_APP_AUTH0_CLIENT_SECRET_ADMIN) -- visible para cualquiera
                    // que abriera las dev tools o viera el codigo fuente publicado, que asi
                    // podia generar sus propios tokens de administracion de Auth0. Ahora ese
                    // llamado a la Management API lo hace la propia API (auth0/organizations,
                    // ver Auth0Api.cs), que si puede guardar el secreto de forma segura, y
                    // aca solo hace falta mandarle nuestro propio Access Token.
                    const authHeader = await buildAuthorizationHeader(getAccessTokenSilently, loginWithRedirect);
                    const organizationIds = await http(new Request(`${domain}/auth0/organizations`, {
                        method: 'GET',
                        headers: { ...authHeader },
                    }));

                    const queryParams = { filter: JSON.stringify({ id: organizationIds }) };
                    const queryString = new URLSearchParams(queryParams).toString();
                    const organizationsdata = await http(new Request(`${domain}/organizations/identifiers?${queryString}`, {
                        method: 'GET',
                        headers: { ...authHeader },
                    }));

                    var organizations = organizationsdata.map(item => (
                        {
                            key: item.id,
                            value: item.name
                        }
                    ));

                    States.setOrganizations(organizations);
                    States.setOrganizationId(organizations[0].key);

                    const companiesdata = await http(new Request(`${domain}/company/user`, {
                        method: 'GET',
                        headers: {
                            user: claims?.sub,
                            username: claims?.nickname,
                            organization: organizations[0].key,
                            ...authHeader,
                        }
                    }));

                    var companies = companiesdata.map(item => (
                        {
                            key: item.id,
                            value: item.name
                        }
                    ));

                    States.setCompanies(companies);

                }
                catch {
                    setCom(<div className="centered"><div className="child"><span>Estamos pasando por problemas, intente en un momento.</span></div></div>);
                    return;
                }

                setCom(<Component {...props} />);
            } catch (e) {
                console.log(e);
            }
        })();
        // "props" queda deliberadamente afuera de este arreglo (aunque se usa arriba, en
        // setCom): es un objeto que puede llegar con una referencia nueva en cada
        // re-render de la ruta que envuelve este HOC, aunque su contenido no haya cambiado
        // en realidad -- si estuviera en las dependencias, cada uno de esos re-renders
        // volveria a disparar TODO este efecto (HandShake + auth0/organizations +
        // organizations/identifiers + company/user) de nuevo, multiplicando llamados de
        // arranque sin necesidad (mismo patron de bug que se encontro y corrigio en
        // Components/*/CompaniesShow.jsx y DownPayment*/DownPaymentShow.jsx). Cuando el
        // efecto si vuelve a correr por otro motivo (cambio real de sesion), usa el "props"
        // mas reciente de todos modos, por clausura.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAuthenticated, getIdTokenClaims, getAccessTokenSilently, loginWithRedirect]);
    return com;
};

export default withValidations